import cx from 'classnames';
import React, { useCallback, useState } from 'react';
import styles from './InventoryType.module.scss';
import {
  useIsManheim,
  useIsMarketPlace,
  useNoVehicle,
  useIsLightAccident
} from '../TileKit/hooks';
import Tooltip from '../Tooltip';

const useInventoryType = (): [string, string, boolean] => {
  const isMarketplace = useIsMarketPlace();
  const isManheim = useIsManheim();
  const isLightAccident = useIsLightAccident();
  const shouldNotDisplayInventoryType = isLightAccident || isManheim;

  if (isMarketplace) {
    return ['Partner', 'marketplace', isMarketplace];
  } else if (shouldNotDisplayInventoryType) {
    return ['', 'hidden', false];
  } else {
    return ['Carvana Certified', 'carvana-certified', isMarketplace];
  }
};

type OwnProps = {
  trackMarketPlaceClicked: () => void;
};

const InventoryType: React.FC<OwnProps> = ({ trackMarketPlaceClicked }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [text, className, isMarketplace] = useInventoryType();
  const noVehicle = useNoVehicle();

  const handleTooltipClick = useCallback((ev: MouseEvent) => {
    ev.stopPropagation();

    setShowTooltip(v => {
      if (!v) trackMarketPlaceClicked();

      return !v;
    });
  }, []);

  return (
    <div
      className={cx(styles['inventory-type'], className, {
        invisible: noVehicle
      })}
      data-qa="inventory-type"
    >
      {isMarketplace ? (
        <Tooltip
          component={
            <>
              <div className="tooltip-title">{text}</div>
              <p className="tooltip-text">
                We have hand-selected a group of partners to provide an even
                broader selection of intelligently curated vehicles for you.
                Each one of these vehicles meets the same high standards as
                Carvana Certified vehicles.
              </p>
            </>
          }
          onClick={handleTooltipClick}
          open={showTooltip}
          qaName="inventory-type"
        >
          {text}
        </Tooltip>
      ) : (
        text
      )}
    </div>
  );
};

export default InventoryType;
